(() => {
  'use strict';
  const chinese = /[\u2E80-\u303F\u3100-\u312F\u31A0-\u31EF\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF\uFE10-\uFE1F\uFE30-\uFE4F\uFF01-\uFF60\uFFE0-\uFFEE\u{20000}-\u{323AF}]/u;
  const family = '"GFE Chinese Text", ';
  const managed = new Map();
  const skipped = 'script,style,noscript';
  let queued = false;
  let observer;
  const options = { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class', 'placeholder', 'value'] };

  function refresh() {
    queued = false;
    observer.disconnect();
    for (const [element, state] of managed) {
      if (!element.isConnected) { managed.delete(element); continue; }
      if (element.style.getPropertyValue('font-family') === state.applied) {
        if (state.value) element.style.setProperty('font-family', state.value, state.priority);
        else element.style.removeProperty('font-family');
      }
    }
    managed.clear();
    const targets = new Set();
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const element = node.parentElement;
      if (element && chinese.test(node.nodeValue || '') && !element.closest(skipped)) targets.add(element);
    }
    for (const element of document.querySelectorAll('input,textarea,select')) {
      if (chinese.test((element.value || '') + (element.placeholder || '') + (element.textContent || ''))) targets.add(element);
    }
    const changes = Array.from(targets, element => ({
      element,
      value: element.style.getPropertyValue('font-family'),
      priority: element.style.getPropertyPriority('font-family'),
      applied: family + getComputedStyle(element).fontFamily
    }));
    for (const state of changes) {
      state.element.style.setProperty('font-family', state.applied, 'important');
      state.applied = state.element.style.getPropertyValue('font-family');
      managed.set(state.element, state);
    }
    document.documentElement.setAttribute('data-gfe-chinese-font', 'ready');
    observer.observe(document.body, options);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(refresh);
  }

  function start() {
    observer = new MutationObserver(schedule);
    refresh();
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('input', schedule, { passive: true });
    document.addEventListener('change', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
